import React from "react";

import { intrductoryData, menuData, uiText } from "../const/profileConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Nav, Navbar } from "react-bootstrap";
import cv from "../cv_apurba_karmaker.pdf";
import { scrollToDiv } from "../utility";

function HeaderSection() {
  return (
    <div className="header-section">
      <div className="my-image-container ms-1 me-1">
        <img className="my-image" src={intrductoryData.image} />
      </div>
      <div className="p-rel m-1 w-100">
        <div className="h-100">
          <h3 className="mob-text-center">{intrductoryData.name}</h3>
          <h5 className="text-lite mob-text-center">
            {intrductoryData.designation}
          </h5>
          <div className="d-flex flex-row mt-1 align-items-center mob-justify-content-center">
            <FontAwesomeIcon className="ml-1" icon={faMapMarkerAlt} />
            <div className="margin-left-1p">{intrductoryData.location}</div>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <a
              className="d-flex justify-content-center align-items-center download-cv"
              href={cv}
              download="cv_apurba_karmaker.pdf"
            >
              {uiText.downloadLabel}
            </a>
          </div>
          <Navbar className="menu-button-wrapper">
            {menuData.map((menu) => {
              return (
                <Nav
                  className="menu-button menu-button"
                  unselectable="on"
                  onClick={() => {
                    scrollToDiv(menu.key);
                  }}
                >
                  {menu.value}
                </Nav>
              );
            })}
          </Navbar>
        </div>
        <hr className="horizontal-row" />
      </div>
    </div>
  );
}

export default HeaderSection;
